import { FC } from 'react';
import styled from 'styled-components';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { NgTooltip } from '../NgTooltip/NgTooltip';

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.aiBackground};
  color: ${({ theme }) => theme.palette.white};
  cursor: pointer;
  transition: filter 0.15s ease;

  &:hover {
    filter: brightness(0.9);
  }

  svg {
    font-size: 13px !important;
  }
`;

interface NgAiSuggestionsButtonProps {
  tooltip?: string;
  className?: string;
  onClick: () => void;
}

export const NgAiSuggestionsButton: FC<NgAiSuggestionsButtonProps> = ({
  tooltip = 'Find similar slides',
  className,
  onClick,
}) => {
  return (
    <NgTooltip title={tooltip} placement="top">
      <StyledButton
        className={className}
        onClick={(e) => {
          e.stopPropagation();
          onClick();
        }}
      >
        <AutoAwesomeIcon />
      </StyledButton>
    </NgTooltip>
  );
};
